import { render, staticRenderFns } from "./VueTour.vue?vue&type=template&id=49b9ac1c&"
import script from "./VueTour.vue?vue&type=script&lang=ts&"
export * from "./VueTour.vue?vue&type=script&lang=ts&"
import style0 from "./VueTour.vue?vue&type=style&index=0&id=49b9ac1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports